"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CCElementInteractionConnect = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _get = _interopRequireDefault(require("lodash/get"));

var _elementInteraction = _interopRequireDefault(require("./element-interaction"));

// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
var CCElementInteraction = function CCElementInteraction(props) {
  var elementInteractionProps = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), {}, {
    eventName: 'CC_ELEMENT_INTERACTION_EVENT',
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    impressionId: props.impressionId
  });
  var ccData = {
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    productId: props.productId,
    // eslint-disable-next-line react/destructuring-assignment -- directive added automatically by Shepherd migration
    productImpressionId: props.productImpressionId
  };
  return /*#__PURE__*/_react.default.createElement(_elementInteraction.default, (0, _extends2.default)({
    verticalInteractionData: ccData
  }, elementInteractionProps));
};

CCElementInteraction.propTypes = {
  productId: _propTypes.default.number.isRequired,
  impressionId: _propTypes.default.string,
  productImpressionId: _propTypes.default.string,
  productImpressionKey: _propTypes.default.string
};
var _default = CCElementInteraction;
exports.default = _default;
var CCElementInteractionConnect = (0, _reactRedux.connect)(function (state, ownProps) {
  return {
    impressionId: (0, _get.default)(state, "impressions[".concat(ownProps.id, "].elementImpressionHeader.impressionId")),
    productImpressionId: (0, _get.default)(state, "impressions[".concat(ownProps.productImpressionKey, "].impressionHeader.impressionId"))
  };
})(CCElementInteraction);
exports.CCElementInteractionConnect = CCElementInteractionConnect;